/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-01-12                                                        *
 ******************************************************************************/

export default {
    data(){
        return {
            keepAliveId: null
        };
    },
    methods:{
        handleSignOut(){
            this.$store.dispatch('DeviseAuthStore/signout')
                .then(()=>{
                    this.clearKeepAlive();
                    window.location.href = '/users/sign_in';
                })
                .catch((error)=>{alert(error.response ? error.response.data : error);});
        },
        loadCurrentUser(){
            this.$store.dispatch('DeviseAuthStore/show')
                .catch((error)=>{alert(error.response ? error.response.data : error);});
        },
        clearKeepAlive(){
            clearInterval(this.keepAliveId);
        }
    },
    mounted(){
        this.loadCurrentUser();
        let that = this;
        this.keepAliveId = setInterval(()=>{that.loadCurrentUser();},1000*60);
    },
    computed: {
        username(){
            if(this.$store.state.DeviseAuthStore.username){
                return this.$store.state.DeviseAuthStore.username;
            }
        },
        has_multiple_roles(){
            if(this.$store.state.DeviseAuthStore.roles_count){
                return this.$store.state.DeviseAuthStore.roles_count > 1;
            }
        }
    }
}
